<div class="standard-dialog">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ 'Notes.CopyToCourse' | translate }}</h2>
      <p class="subtitle">{{ 'Notes.SelectCourseSubtitle' | translate }}</p>
    </div>
    <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="form-content">
    <div class="w-full mb-3">
      <ui-input [(ngModel)]="searchInput" (ngModelChange)="filterCourses()" prefixIcon="search" [placeholder]="'Global.FilterCourses' | translate" />
    </div>

    @if (loading) {
      <div class="flex justify-center items-center py-10">
        <mat-spinner diameter="36" />
      </div>
    } @else {
      <div class="course-list">
        @for (course of filteredCourses; track course._id) {
          <div (click)="selectCourse(course)" class="course-item">
            <mat-icon class="course-item__icon">school</mat-icon>
            <span class="course-item__name">{{ course.actualName }}</span>
          </div>
        } @empty {
          @if (!loading) {
            <div class="empty-state">
              <mat-icon>search_off</mat-icon>
              <p>{{ 'Global.NoCoursesFound' | translate }}</p>
            </div>
          }
        }
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <div class="right-actions">
      <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
    </div>
  </mat-dialog-actions>
</div>
